export default {
  isAuthenticated: false,
  accessToken: null,
  user: null,
  permissions: [],
};
